import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English
import enCommon from "./en/common.json";
import enDashboard from "./en/dashboard.json";
import enProfile from "./en/profile.json";
import enPlans from "./en/plans.json";
import enWishlist from "./en/wishlist.json";
import enSettings from "./en/settings.json";

// Hindi
import hiCommon from "./hi/common.json";
import hiDashboard from "./hi/dashboard.json";
import hiProfile from "./hi/profile.json";
import hiPlans from "./hi/plans.json";
import hiWishlist from "./hi/wishlist.json";
import hiSettings from "./hi/settings.json";

// Marathi
import mrCommon from "./mr/common.json";
import mrDashboard from "./mr/dashboard.json";
import mrProfile from "./mr/profile.json";
import mrPlans from "./mr/plans.json";
import mrWishlist from "./mr/wishlist.json";
import mrSettings from "./mr/settings.json";

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    profile: enProfile,
    plans: enPlans,
    wishlist: enWishlist,
    settings: enSettings,
  },
  hi: {
    common: hiCommon,
    dashboard: hiDashboard,
    profile: hiProfile,
    plans: hiPlans,
    wishlist: hiWishlist,
    settings: hiSettings,
  },
  mr: {
    common: mrCommon,
    dashboard: mrDashboard,
    profile: mrProfile,
    plans: mrPlans,
    wishlist: mrWishlist,
    settings: mrSettings,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    ns: ["common", "dashboard", "profile", "plans", "wishlist", "settings"],
    defaultNS: "common",
    fallbackNS: ["common", "dashboard"],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "cookie", "nav", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
